import React from "react";
import CheckCircleOutline from "@mui/icons-material/CheckCircleOutline";
import deleteButton from "../../images/icon-delete.svg";

type FileUploadDisplayProps = {
    onClick: () => void;
    label: React.ReactNode;
    uploadedFile: File | null;
    onDelete: () => void;
    inputId: string;
};

export function FileUploadDisplay({
                                      onClick,
                                      label,
                                      uploadedFile,
                                      onDelete,
                                      inputId
                                  }: FileUploadDisplayProps) {
    if (uploadedFile) {
        return (
          <div id={inputId}
               className={`rounded-xl p-3 flex items-center text-sm h-16 border border-solid border-gray-200 bg-gray-50 justify-between`}>
                    <span className="flex items-center gap-2 text-green-600 font-medium truncate pr-2">
                        <span className="truncate">{uploadedFile.name}</span>
                        <CheckCircleOutline fontSize="small" />
                    </span>
              <button type="button" onClick={onDelete}
                      className="text-red-500 hover:text-red-700 p-1 -mr-1 shrink-0">
                  <img src={deleteButton} alt="Delete icon" />
              </button>
          </div>
        );
    }

    return (
      <button id={inputId} type="button" onClick={onClick}
              className={`rounded-xl p-3 flex items-center text-sm h-16 w-full border border-dashed border-gray-300 justify-center text-center cursor-pointer hover:border-gray-400 hover:bg-gray-50 text-gray-500`}>
          <span className="inline-block">{label}</span>
      </button>
    );
};
